import React from 'react';
import Particle from './../../Particle'; //eslint-disable-line no-unused-vars
import {Paragraph, Title} from './../../Basics';

const Particle02 = () => (<div>

  <Title>The six Cybathlon disciplines</Title>

  <Title level={3}>1. Exoskeleton obstacle course</Title>
  <Paragraph>
    Exoskeletons are robotic support structures attached to the legs. They enable paraplegics to stand upright,
    walk and even climb stairs, though very slowly. Keeping one’s balance is also difficult.
  </Paragraph>

  <Particle
    number={15}
  />
                          
  <Title level={3}>2. Dexterity course with arm prostheses</Title>
  <Paragraph>
    This course was for participants missing one or both arms and wearing high-tech prostheses. Assignments included
    carrying beverage crates up and down steps, screwing a lightbulb into a socket, setting a table and hanging laundry.
  </Paragraph>
   
  <Particle
    number={12}
  />

  <Title level={3}>3. Virtual race via thought control </Title>
  <Paragraph>
    Pilots in this race are completely paralysed. Their task was to control characters in a computer game through their
    thought alone. This requires a so-called brain-computer interface.
  </Paragraph>
                          
  <Particle
    number={19}
  />

  <Title level={3}>4. Bike race by means of muscle stimulation</Title>
  <Paragraph>
     Paraplegics have damaged spinal nerves, which means that they are unable to move their legs. However, the muscles
     in their legs remain intact. It is therefore possible to stimulate them via electrodes placed on the skin, causing
     them to contract. During the bike race, the competitors themselves controlled the electricity supply to their muscles,
     while covering the 750 meters as quickly as possible.
  </Paragraph>

  <Particle
    number={24}
  />
                          
    <Title level={3}>5. Motorised wheelchair circuit</Title>
  <Paragraph>
      Wheelchair users are confronted with stairs, thresholds and other obstacles each and every day. The circuit consisted of
      such barriers, and the pilots’ task was to overcome them in motorised wheelchairs using a joystick, touchpad or other technologies.
  </Paragraph>
 
  <Particle
    number={9}
  />
  
  <Title level={3}>6. Prosthetic leg skills course</Title>
  <Paragraph>
    In this discipline, prosthetic leg wearers were asked to perform various step sequences and movements that only skilled pilots
    donning high-technology prostheses can master.
  </Paragraph>
                          
</div>);

export default Particle02;



/** WEBPACK FOOTER **
 ** ./src/Particles/Particle02/Particle02_EN.js
 **/